import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/office/jpg-png/spb-1.jpg")